import { BaseHttpProvider } from "./base-http.provider"

export class ContactUsProvider extends BaseHttpProvider {
  async find(locale: string) {
    const response = await this.execute({
      uri: `/contact-us?_locale=${locale}`,
      method: "GET",
    })

    return response
  }
}
